module.exports = __webpack_public_path__ + "static/media/1000d.683debfb.jpg";